export const EXPERIENCE_FUNCTION_MODEL = "experience-function";

const experienceFunctionModel = {
  name: "",
  category: ""
};

export default experienceFunctionModel;
